document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('create_customer_form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
        const acceptsMarketing = document.querySelector('input#accepts-marketing').checked;

        if (acceptsMarketing) {
            const firstName = document.getElementById('FirstName').value;
            const lastName = document.getElementById('LastName').value;
            const email = document.getElementById('Email').value;

            if (typeof _learnq !== 'undefined') {

            _learnq.push(['track', 'Customer Account Create', {
                'acceptsMarketing': true,
                'email': email,
                'firstName': firstName,
                'lastName': lastName,
                'userId': email,
                'value': email
            }]);

            } else {
            console.error('❌ Klaviyo (_learnq) not loaded');
            }
        } else {
            console.log('Newsletter subscription not selected, skipping Klaviyo');
        }
    });
});